<template>
    <h-form :ref="ref" :model="formModel" :label-width="labelWidth" :cols="columns">
      <h-form-item v-for="(it, index) in simpleItems" :prop="it.prop" :label="it.label" :key="index">
        <!--支持范围查询条件,且字段名约定以begin和end结尾-->
        <h-row v-if="it.isRangeQuery">
          <h-col span="11">
            <h-form-item :prop="it.prop+'Begin'">
              <h-input v-model="model[it.prop+'Begin']" :type="it.type" :placeholder="it.placeholder == '' ? it.label : it.placeholder" :specialFilter = "it.specialFilter" :specialDecimal = "it.specialDecimal"></h-input>
            </h-form-item>
          </h-col>
          <h-col span="2" style="text-align: center">-</h-col>
          <h-col span="11">
            <h-form-item :prop="it.prop+'End'">
              <h-input v-model="model[it.prop+'End']" :type="it.type" :placeholder="it.placeholder==''?it.label:it.placeholder" :specialFilter = "it.specialFilter" :specialDecimal = "it.specialDecimal"></h-input>
            </h-form-item>
          </h-col>
        </h-row>
        <h-input v-else-if="it.type === 'int'" type="int" v-model.trim="model[it.prop]" :special-filter="it.specialFilter" :special-length="it.specialLength" :placeholder="it.placeholder == '' ? it.label : it.placeholder"></h-input>
        <h-select v-else-if="it.type === 'select'" :showTitle="true" v-model.trim="model[it.prop]" :placeholder="it.placeholder == '' ? it.label : it.placeholder" :multiple="it.multiple" :filterable="it.filterable" @on-drop-change="dropChange(it.isEnableDropChange)" @on-item-remove="itemRemove(it.isEnableItemRemove)">
          <h-option v-for="(item) in dicts[it.prop]" :value="item.value" :key="item.value">{{item.labelInValue | labelInValueFilter(item.label)}}</h-option>
        </h-select>
        <h-date-picker v-else-if="it.type === 'date'" :type="it.dateType" v-model="model[it.prop]" :format="it.format" :placement="it.placement" :placeholder="it.placeholder" :disabled="it.disabled" :clearable="it.clearable" :readonly="it.readonly" :show-format="it.showFormat" :transfer="it.transfer" :options="it.limitRange === true ? options : ''"></h-date-picker>
        <h-time-picker v-else-if="it.type === 'time'" :type="it.dateType" v-model="model[it.prop]" :format="it.format" :placement="it.placement" :placeholder="it.placeholder" :disabled="it.disabled" :clearable="it.clearable" :readonly="it.readonly" :confirm="it.confirm" :transfer="it.transfer"></h-time-picker>
        <h-input v-else v-model.trim="model[it.prop]" :placeholder="it.placeholder == '' ? it.label : it.placeholder"></h-input>
      </h-form-item>
      <template v-if="enableAdvanced">
        <h-form-item v-for="(it, index) in advancItems" :prop="it.prop" :label="it.label" :key="index" v-show="isAdvanced">
          <!--支持范围查询条件,且字段名约定以begin和end结尾-->
          <h-row v-if="it.isRangeQuery">
            <h-col span="11">
              <h-form-item :prop="it.prop+'Begin'">
                <h-input v-model="model[it.prop+'Begin']" :type="it.type" :placeholder="it.placeholder == '' ? it.label : it.placeholder" :specialFilter = "it.specialFilter" :specialDecimal = "it.specialDecimal"></h-input>
              </h-form-item>
            </h-col>
            <h-col span="2" style="text-align: center">-</h-col>
            <h-col span="11">
              <h-form-item :prop="it.prop+'End'">
                <h-input v-model="model[it.prop+'End']" :type="it.type" :placeholder="it.placeholder==''?it.label:it.placeholder" :specialFilter = "it.specialFilter" :specialDecimal = "it.specialDecimal"></h-input>
              </h-form-item>
            </h-col>
          </h-row>
          <h-input v-else-if="it.type === 'int'" type="int" v-model.trim="model[it.prop]" :special-filter="it.specialFilter" :special-length="it.specialLength" :placeholder="it.placeholder == '' ? it.label : it.placeholder"></h-input>
          <h-select v-else-if="it.type === 'select'" :showTitle="true" v-model.trim="model[it.prop]" :placeholder="it.placeholder == '' ? it.label : it.placeholder" :multiple="it.multiple" :filterable="it.filterable" @on-drop-change="dropChange(it.isEnableDropChange)" @on-item-remove="itemRemove(it.isEnableItemRemove)">
            <h-option v-for="(item) in dicts[it.prop]" :value="item.value" :key="item.value">{{item.labelInValue | labelInValueFilter(item.label)}}</h-option>
          </h-select>
          <h-date-picker v-else-if="it.type === 'date'" :type="it.dateType" v-model="model[it.prop]" :format="it.format" :placement="it.placement" :placeholder="it.placeholder" :disabled="it.disabled" :clearable="it.clearable" :readonly="it.readonly" :show-format="it.showFormat" :transfer="it.transfer" :options="it.limitRange === true ? options : ''"></h-date-picker>
          <h-time-picker v-else-if="it.type === 'time'" :type="it.dateType" v-model="model[it.prop]" :format="it.format" :placement="it.placement" :placeholder="it.placeholder" :disabled="it.disabled" :clearable="it.clearable" :readonly="it.readonly" :confirm="it.confirm" :transfer="it.transfer"></h-time-picker>
          <h-input v-else v-model.trim="model[it.prop]" :placeholder="it.placeholder == '' ? it.label : it.placeholder"></h-input>
        </h-form-item>
      </template>
      <!-- 搜索/重置按钮区域 -->
      <!-- <h-form-item :style="styleEl" label-width="0" :class='["no-label", isAdvanced ? "align-right" : ""]' :align="alignRight"> -->
        <h-form-item label-width="0" :class='["no-label", isAdvanced ? "align-right" : ""]' :align="alignRight">
        <h-button type="primary" style="margin-right:8px;" @click.prevent="searchHandle" >{{$t('m.i.common.search')}}</h-button>
        <h-button style="margin-right:8px;" @click.prevent="resetHandle" >{{$t('m.i.common.reset')}}</h-button>
        <h-button v-if="enableAdvanced" @click.prevent="changeHandle" class="sad-btn">
          {{advancedText}}
          <h-icon name="unfold"></h-icon>
        </h-button>
      </h-form-item>
    </h-form>
</template>
<script>
export default {
  name: 'HSearchForm',
  props: {
    ref: {
      type: String,
      default: 'searchForm'
    },
    // 表单对象
    model: {
      type: Object,
      required: true
    },
    // 字典对象
    dicts: {
      type: Object,
      required: true
    },
    // 搜索字段
    formItems: {
      type: Array,
      required: true
    },
    // 是否启用高级功能
    enable: {
      type: Boolean,
      default: false
    },
    // 表单标签宽度
    labelWidth: {
      type: Number,
      default: 80
    },
    // 表单列数
    columns: {
      type: Number,
      default: 4
    },
    // 初始显示字段数量
    initSize: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      isAdvanced: false,
      formModel: this.model,
      options: {
        disabledDate (date) {
          return date && date.valueOf() >= Date.now()
        }
      },
      styleEl: {
        width: this.enable ? '220px' : '160px'
      }
    }
  },
  filters: {
    labelInValueFilter (v, s) {
      return v || s
    }
  },
  computed: {
    enableAdvanced () {
      return this.enable
    },
    advancedText () {
      return this.isAdvanced ? this.$t('m.i.common.searchSimple') : this.$t('m.i.common.searchAdvanced')
    },
    alignRight () {
      return this.isAdvanced ? 'right' : 'left'
    },
    simpleItems () {
      let size = this.initSize
      return this.enableAdvanced ? this.formItems.slice(0, size) : this.formItems
    },
    advancItems () {
      let size = this.initSize
      return this.formItems.slice(size, this.formItems.length)
    }
  },
  watch: {
    model (nv, v) {
      this.formModel = nv
    }
  },
  methods: {
    searchHandle () {
      this.$emit('search')
    },
    resetHandle () {
      this.$refs[this.ref].resetFields()
      this.$emit('reset')
    },
    changeHandle () {
      this.isAdvanced = !this.isAdvanced
      this.$emit('change', this.isAdvanced)
    },
    getForm () {
      return this.$refs[this.ref]
    },
    // 下拉框支持多选时
    dropChange (isEnableDropChange) {
      // 弹框关闭/展开时触发
      if (isEnableDropChange) {
        this.$emit('onDropChange')
      }
    },
    itemRemove (isEnableItemRemove) {
      // 移除时触发
      if (isEnableItemRemove) {
        this.$emit('onItemRemove')
      }
    },
    resetForm () {
      this.getForm().resetFields()
    }
  }
}
</script>
<style scoped>

</style>
